import { GovernanceRole, EducationItem, VolunteerItem } from '../types/content';

export const governanceRoles: GovernanceRole[] = [
  {
    title: 'Executive Board Chairperson',
    org: 'Illinois Center for Autism',
    period: 'Chair 07/2026 to Present, Vice Chair 01/2023 to 07/2026, Member since 08/2014',
    description: 'Leading facility expansion plans for the organization.'
  },
  {
    title: 'Civic Data Engineering',
    org: 'St. Louis Crisis Nursery',
    period: 'Volunteer Engagement',
    description:
      'Created a data reporting system, reducing monthly counselor reporting time from 10 hours to 0.5 hours.'
  }
];

export const educationItems: EducationItem[] = [
  {
    degree: 'MBA',
    school: 'Washington University in St. Louis, Olin Business School',
    details: [
      'Beta Gamma Sigma, top 20% of class',
      'President of Net Impact Club',
      'Anheuser-Busch InBev Case Competition Winner'
    ]
  },
  {
    degree: 'BA in Education with High Distinction',
    school: 'University of Michigan, Ann Arbor',
    details: ['GPA 3.635 out of 4.0', 'James B. Angell Scholar', 'Study Abroad at UNSW Australia']
  }
];

export const volunteerItems: VolunteerItem[] = [
  {
    title: 'Ready Readers',
    description: 'Pre-K literacy volunteer.'
  },
  {
    title: 'Volunteer Teacher',
    description: 'Taught in Nairobi and a Maasai village in Kenya.'
  }
];
